/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { SchematisationRevision } from "./SchematisationRevision";
import {
  SchematisationRevisionFromJSON,
  SchematisationRevisionFromJSONTyped,
  SchematisationRevisionToJSON,
  SchematisationRevisionToJSONTyped,
} from "./SchematisationRevision";

/**
 *
 * @export
 * @interface PaginatedSchematisationRevisionList
 */
export interface PaginatedSchematisationRevisionList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<SchematisationRevision>;
}

/**
 * Check if a given object implements the PaginatedSchematisationRevisionList interface.
 */
export function instanceOfPaginatedSchematisationRevisionList(
  value: object
): value is PaginatedSchematisationRevisionList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedSchematisationRevisionListFromJSON(
  json: any
): PaginatedSchematisationRevisionList {
  return PaginatedSchematisationRevisionListFromJSONTyped(json, false);
}

export function PaginatedSchematisationRevisionListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedSchematisationRevisionList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(SchematisationRevisionFromJSON),
  };
}

export function PaginatedSchematisationRevisionListToJSON(
  json: any
): PaginatedSchematisationRevisionList {
  return PaginatedSchematisationRevisionListToJSONTyped(json, false);
}

export function PaginatedSchematisationRevisionListToJSONTyped(
  value?: PaginatedSchematisationRevisionList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(SchematisationRevisionToJSON),
  };
}
